export default function iconDirective() {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		scope: {
			icon: "@",
			text: "@"
		},
		templateUrl: "./components/icon/icon-template.html",
		link: (scope, element, attrs) => {
			switch (attrs.source) {
				case "pm":	//project icons
					scope.base = "icon__base";
					scope.prefix = "icon";
					break;
				case "maps":	//mapsws icons
					scope.prefix = "mapsicon";
					break;
				case "lds":     //lds icons
				default:
					scope.base = "lumen-icon";
					scope.prefix = "lumen-icon__graphic lumen-icon__graphic-";
					break;
			}
		}
	};
}
